module.exports = __webpack_public_path__ + "static/media/factories-1.dff44c1b.jpg";